/**
 * Marketing conversion value configuration.
 *
 * Phase 2 (free_signup value-based bidding): the SPA pushes a standalone
 * estimated value with each free signup so Google Ads "Maximize conversion
 * value" can weight free vs paid Primary actions. Tune via
 * VITE_FREE_SIGNUP_CONVERSION_VALUE without changing Google Ads action
 * settings when GTM maps {{DLV - value}} on the free-signup tag.
 *
 * Use a modest standalone estimate ($0.50–$1.00) — not paid ARPU — because
 * upgrading users also fire subscription_purchase with real value.
 */

/** ISO 4217 currency for free-signup conversion value reporting. */
export const FREE_SIGNUP_CONVERSION_CURRENCY = 'USD';

/** Default estimated value (USD) when the env var is unset or invalid. */
export const DEFAULT_FREE_SIGNUP_CONVERSION_VALUE = 1.0;

/**
 * Resolved free-signup conversion value in major currency units (e.g. 1.0 USD).
 * Reads `VITE_FREE_SIGNUP_CONVERSION_VALUE` at build time; falls back to
 * {@link DEFAULT_FREE_SIGNUP_CONVERSION_VALUE} when missing or non-numeric.
 */
export function getFreeSignupConversionValue(): number {
  const raw = import.meta.env.VITE_FREE_SIGNUP_CONVERSION_VALUE;
  if (typeof raw !== 'string' || raw.trim() === '') {
    return DEFAULT_FREE_SIGNUP_CONVERSION_VALUE;
  }

  const parsed = Number.parseFloat(raw.trim());
  if (!Number.isFinite(parsed) || parsed < 0) {
    return DEFAULT_FREE_SIGNUP_CONVERSION_VALUE;
  }

  return parsed;
}
